import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import "./history.css";

// Hàm dịch mã số thành Lựa chọn (Tài/Xỉu, Chẵn/Lẻ, Xóc Đĩa, Xổ Số...)
const GetNameChoose = (state, type, sanh) => {
    if (state == null || state === undefined) return "";
    let stateStr = state.toString();

    if (sanh) {
        let nameLower = sanh.toLowerCase();

        // Xử lý Xóc đĩa
        if (nameLower.includes("xóc đĩa") || nameLower.includes("xoc dia")) {
            let res = [];
            stateStr.split(" ").forEach((item) => {
                if (Number(item) === 1 && type == null) res.push("4 đỏ");
                if (Number(item) === 2 && type == null) res.push("4 trắng");
                if (Number(item) === 3 && type == null) res.push("3 đỏ 1 trắng");
                if (Number(item) === 4 && type == null) res.push("3 trắng 1 đỏ");
                if (Number(item) === 5 && type == null) res.push("Chẵn");
                if (Number(item) === 6 && type == null) res.push("Lẻ");
            });
            return res.length > 0 ? res.join(", ") : stateStr;
        }

        // Xử lý Tài xỉu
        if (nameLower.includes("tài xỉu") || nameLower.includes("tai xiu") || sanh === "TXMD560s") {
            let res = [];
            stateStr.split(" ").forEach((item) => {
                if (Number(item) === 1 && type == null) res.push("Chẵn");
                if (Number(item) === 2 && type == null) res.push("Lẻ");
                if (Number(item) === 3 && type == null) res.push("Tài");
                if (Number(item) === 4 && type == null) res.push("Xỉu");
            });
            return res.length > 0 ? res.join(", ") : stateStr;
        }

        // Xử lý các game khác (CatDog, Greedy...)
        if (sanh === "CatDog") {
            let res = [];
            stateStr.split(" ").forEach((item) => {
                if (Number(item) === 1 && type == null) res.push("Mèo");
                if (Number(item) === 2 && type == null) res.push("Hòa");
                if (Number(item) === 3 && type == null) res.push("Chó");
                if (Number(item) === 4 && type == null) res.push("Nổ hũ Mèo");
                if (Number(item) === 5 && type == null) res.push("Nổ hũ Chó");
            });
            return res.length > 0 ? res.join(", ") : stateStr;
        }
    }

    // Các môn Xổ Số
    if (type == 1 && state != null) return "Lô 2: " + stateStr;
    if (type == 2 && state != null) return "3 càng ĐB: " + stateStr;
    if (type == 3 && state != null) return "Đề ĐB: " + stateStr;
    if (type == 4 && state != null) return "Lô xiên 2: " + stateStr;
    if (type == 5 && state != null) return "Lô xiên 3: " + stateStr;
    if (type == 6 && state != null) return "Lô xiên 4: " + stateStr;
    if (type == 7 && state != null) return "Trượt xiên 4: " + stateStr;
    if (type == 8 && state != null) return "Trượt xiên 8: " + stateStr;
    if (type == 9 && state != null) return "Lô 2 số đầu: " + stateStr;
    if (type == 10 && state != null) return "Lô 2 số 1K: " + stateStr;
    if (type == 11 && state != null) return "Lô 3 số: " + stateStr;
    if (type == 12 && state != null) return "Lô 4 số: " + stateStr;
    if (type == 13 && state != null) return "Đề đầu ĐB: " + stateStr;
    if (type == 14 && state != null) return "Đề giải 7: " + stateStr;
    if (type == 15 && state != null) return "Đề giải nhất: " + stateStr;
    if (type == 16 && state != null) return "Đề đầu giải nhất: " + stateStr;
    if (type == 17 && state != null) return "Đầu: " + stateStr;
    if (type == 18 && state != null) return "Đuôi: " + stateStr;
    if (type == 19 && state != null) return "3 càng đầu: " + stateStr;
    if (type == 20 && state != null) return "Đề đầu đuôi: " + stateStr;
    if (type == 21 && state != null) return "3 càng đầu đuôi: " + stateStr;
    if (type == 22 && state != null) return "4 càng ĐB: " + stateStr;
    if (type == 23 && state != null) return "Trượt xiên 10: " + stateStr;
    if (type == 24 && state != null) return "3 càng giải nhất: " + stateStr;
    if (type == 25 && state != null) return "Đề giải 8: " + stateStr;

    return stateStr;
};

function Historybet() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }
    
    const [history, setHistory] = useState(null);
    const [historyGame, setHistoryGame] = useState(null);
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const navigate = useNavigate();
    
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
            .then((res) => {
                setHistory(res.data.data);
            })
            .catch((err) => console.log(err));
    }, [historyGame]);

    const XSMN = [
        "Bạc Liêu", "Vũng Tàu", "Tiền Giang", "Kiên Giang", "Đà Lạt", "Bình Phước",
        "Bình Dương", "An Giang", "Bình Thuận", "Cà Mau", "Cần Thơ", "Hậu Giang",
        "Đồng Tháp", "Tây Ninh", "Vĩnh Long", "Trà Vinh", "Sóc Trăng", "Long An",
        "TP. HCM", "Đồng Nai", "Bến Tre"
    ];
    
    const XSMT = [
        "Đà Nẵng", "Thừa T. Huế", "Quảng Trị", "Phú Yên", "Quảng Bình", "Quảng Nam",
        "Quảng Ngãi", "Ninh Thuận", "Kon Tum", "Khánh Hòa", "Gia Lai", "Bình Định",
        "Đắk Lắk", "Đắk Nông"
    ];
    
    const checkCancel = (item) => {
        const datexs = new Date(item.id_bet);
        const ngayxs = datexs.getDate();
        const thangxs = datexs.getMonth() + 1;
        const namxs = datexs.getFullYear();
        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
        const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();

        if (item.sanh === "XSMB" && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1800) {
            return 0;
        } else if (XSMT.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1700) {
            return 0;
        } else if (XSMN.includes(item?.sanh) && item?.id_bet == formattedDate && Number(currentDate.getHours() + "" + minute) >= 1600) {
            return 0;
        } else {
            return 1;
        }
    };
    
    return (
        <>
            <div className="historyrecharge">
                <div className="top_title">
                    <div className="txt">Lịch sử trò chơi</div>
                </div>
                {history ? (
                    <div className="main-history">
                        <div className="header-history">
                            <div style={{ width: "10%" }}>Kỳ</div>
                            <div style={{ width: "10%" }}>Sảnh</div>
                            <div style={{ width: "30%" }}>Lựa chọn</div>
                            <div style={{ width: "10%" }}>Điểm cược</div>
                            <div style={{ width: "10%" }}>Điểm thắng</div>
                            <div style={{ width: "15%" }}>Trạng thái</div>
                            <div style={{ width: "15%" }}>Thời gian</div>
                        </div>
                        {history?.map((item, key) => (
                            <div className="content-history" key={key}>
                                <div style={{ width: "10%" }}>{item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}</div>
                                <div style={{ width: "10%" }}>{item?.sanh}</div>
                                
                                {/* CỘT LỰA CHỌN ĐƯỢC DỊCH SANG TIẾNG VIỆT */}
                                <div style={{ width: "30%", color: "red" }}>
                                    {GetNameChoose(item?.state, item?.type, item?.sanh)}
                                </div>
                                
                                {/* CỘT ĐIỂM CƯỢC: CHIA 1000 */}
                                <div style={{ width: "10%" }}>{Math.floor((item?.money || 0) / 1000).toLocaleString("vi-VN")}</div>
                                
                                {/* CỘT ĐIỂM THẮNG: CHIA 1000 */}
                                <div style={{ width: "10%" }}>{Math.floor((item?.moneythang || 0) / 1000).toLocaleString("vi-VN")}</div>
                                
                                <div style={{ width: "15%" }}>
                                    <span
                                        className={`text_status ${
                                            item.status_bet === "Pending" ? "pending" : item.status_bet === "Win" ? "win" : item.status_bet === "Lose" ? "lose" : "cancelled"
                                        }`}>
                                        {item.status_bet === "Pending" ? "Chờ xổ" : item.status_bet === "Win" ? "Thắng" : item.status_bet === "Lose" ? "Thua" : "Đã hủy"}
                                    </span>
                                    {item?.status_bet === "Pending" && (
                                        <>
                                            {(item?.sanh == "XSMB" || XSMN.includes(item?.sanh) || XSMT.includes(item?.sanh)) && (
                                                <>
                                                    {checkCancel(item) == 1 && (
                                                        <span
                                                            className="cancel-bet text_status"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.target.style.display = "none";
                                                                const currentDate = new Date();
                                                                const day = currentDate.getDate();
                                                                const month = currentDate.getMonth() + 1;
                                                                const year = currentDate.getFullYear();
                                                                const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
                                                                const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();
                                                                if (
                                                                    item.sanh === "XSMB" &&
                                                                    Number(currentDate.getHours() + "" + minute) >= 1800 &&
                                                                    Number(currentDate.getHours() + "" + minute) < 1915
                                                                ) {
                                                                    swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                    e.stopPropagation();
                                                                    return;
                                                                } else if (
                                                                    XSMT.includes(item?.sanh) &&
                                                                    item?.id_bet == formattedDate &&
                                                                    Number(currentDate.getHours() + "" + minute) >= 1700 &&
                                                                    Number(currentDate.getHours() + "" + minute) < 1815
                                                                ) {
                                                                    swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                    e.stopPropagation();
                                                                    return;
                                                                } else if (
                                                                    XSMN.includes(item?.sanh) &&
                                                                    item?.id_bet == formattedDate &&
                                                                    Number(currentDate.getHours() + "" + minute) >= 1600 &&
                                                                    Number(currentDate.getHours() + "" + minute) < 1715
                                                                ) {
                                                                    swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
                                                                    e.stopPropagation();
                                                                    return;
                                                                }
                                                                axios
                                                                    .patch(`${process.env.REACT_APP_API_URL}/history/cancel`, {
                                                                        id: item?._id,
                                                                        userId: item?.user?._id,
                                                                        money: item?.money
                                                                    })
                                                                    .then((res) => {
                                                                        setShow(false);
                                                                        swal("Hủy cược thành công", "", "success").then(() => {
                                                                            setHistoryGame(Date.now()); 
                                                                        });
                                                                    })
                                                                    .catch((err) => {
                                                                        setShow(false);
                                                                        swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                                                                        e.target.style.display = "inline-block";
                                                                    });
                                                            }}>
                                                            &times; Hủy cược
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                                <div style={{ width: "15%" }}>{formatDate(new Date(item?.createdAt))}</div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        </>
    );
}
export default Historybet;